import { addFilters, getPlaceDetails, selectPlaceFilters } from 'containers/MapDetails/placeSlice'
import { getMapData } from 'containers/Playground/playgroundSlice'
import { useReduxDispatch, useReduxSelector } from 'store'
import usePlaceMapParams from './hooks/usePlaceMapParams'
import { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import Loading from 'components/Loading'

const PlaceMapData = ({ children, showMap }) => {
  const filters = useReduxSelector(selectPlaceFilters)
  const [isLoading, setLoading] = useState(true)
  const { placeId } = usePlaceMapParams()
  const currentFilters = useRef(filters)
  currentFilters.current = filters

  const dispatch = useReduxDispatch()
  const { replace } = useHistory()

  useEffect(() => {
    if (window.location.search) {
      const query = new URLSearchParams(window.location.search)
      const warehouseTypeId = query.get('warehouseTypeId')
      const hash = query.get('hash')
      if ((warehouseTypeId && warehouseTypeId !== 'undefined') || (hash && hash !== 'undefined')) {
        const attributes = { ...currentFilters.current.attributes }
        if (warehouseTypeId) attributes.warehouseTypeId = warehouseTypeId
        if (hash) attributes.hash = hash
        dispatch(addFilters({
          filters: {
            ...currentFilters.current,
            status: { isAvailableForRent: true },
            attributes
          }
        }))
        replace(window.location.pathname)
      }
    } else {
      dispatch(addFilters({
        filters: {
          ...currentFilters.current,
          status: { isAvailableForRent: true }
        }
      }))
    }

    return () => {
      const { status, ...filters } = currentFilters.current
      dispatch(addFilters({ filters }))
    }
  }, [dispatch, replace])

  useEffect(() => {
    dispatch(getPlaceDetails(placeId)).then(({ payload }) => {
      const displayOptions = payload?.places?.[0]?.displayOptions
      if (displayOptions?.listAllWarehouses || displayOptions?.showList || displayOptions?.showMap) {
        setLoading(false)
        showMap(!!displayOptions?.showMap)
        dispatch(getMapData(placeId))
      } else {
        replace(`/mapdetails/${placeId}`)
      }
    })
  }, [dispatch, placeId, replace, showMap])

  return isLoading
    ? <Loading />
    : children
}

export default PlaceMapData